export const setData = (data = {}) => ({
  type: 'SET_DATA',
  data
})